import ContratTemplateName from '@/generated/controls/contratTemplate/ContratTemplateName.vue';
import { defineComponent } from 'vue';

export default defineComponent({
  components: {},
  extends: ContratTemplateName
})
